import React, { useEffect, useRef } from "react";

function redirectTo(url) {
  window.location.replace(url);
}

function DownloadRedirect({ destination, appName = "Mondoway", openUrl = redirectTo }) {
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (!hasRedirected.current) {
      hasRedirected.current = true;
      openUrl(destination);
    }
  }, [destination, openUrl]);

  return (
    <section className="min-h-[60vh] bg-[#FAF8F2] px-6 py-20 text-center">
      <h1 className="text-2xl font-bold text-[#1E1B16]">Opening {appName}…</h1>
      <p className="mt-3 text-[#4D4B46]">
        If you are not redirected automatically, use the link below.
      </p>
      <a
        href={destination}
        className="mt-6 inline-block rounded-xl bg-[#6A0DAD] px-6 py-3 font-semibold text-white transition-colors hover:bg-[#4C087D] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#6A0DAD]/25"
      >
        Continue to {appName}
      </a>
    </section>
  );
}

export default DownloadRedirect;
